import {
  createContext,
  useContext,
  useState,
  useMemo,
  type ReactNode,
  type Dispatch,
  type SetStateAction
} from "react";

export interface PreconstructionLogContextValue {
  isSidebarOpen: boolean;
  setIsSidebarOpen: Dispatch<SetStateAction<boolean>>;
  sidebarMetadata: {
    feature: "comments" | string;
    itemDetails: any | null;
  } | null;
  setSidebarMetadata: Dispatch<
    SetStateAction<{
      feature: "comments" | string;
      itemDetails: any | null;
    } | null>
  >;
}

const PreconstructionLogContext =
  createContext<PreconstructionLogContextValue | null>(null);

export function usePreconstructionLogContext() {
  const context = useContext(PreconstructionLogContext);
  if (!context) {
    throw new Error(
      "usePreconstructionLogContext must be used within PreconstructionLogProvider"
    );
  }
  return context;
}

export function PreconstructionLogProvider({
  children
}: {
  children: ReactNode;
}) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [sidebarMetadata, setSidebarMetadata] = useState<{
    feature: string;
    itemDetails: any | null;
  } | null>({
    feature: "",
    itemDetails: null
  });

  const value = useMemo(
    () => ({
      isSidebarOpen,
      setIsSidebarOpen,
      sidebarMetadata,
      setSidebarMetadata
    }),
    [isSidebarOpen, sidebarMetadata]
  );

  return (
    <PreconstructionLogContext.Provider value={value}>
      {children}
    </PreconstructionLogContext.Provider>
  );
}
